/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![WidgetsMinusIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABHUlEQVR4nOVUS07DQAz1iiVHKKKcBVTR8dhEGtkKt+B7BEKP1YqjFHqFsCky0CpK00xmQALBk7zKGz87th/AbwaznCDpnSO5cS6MeskhhAPP8ogkz551vQlkWXrWyr43+Y7lDEletzzSGklnk8nlYaeAJWkm7ohqw7UknmXVzZOVie8IfFa6VwBZllsu6ayXS1pPi3Lc7mAdCwCA86I8sgQxrs0mSwBJr4dwPctVpoDcD6i+tk6zZjAtynHsF9mMkrcISR+aK9q3RZ2r+nEHWrU7wT13YEms0mY377dwoafwnXAujOySPcstYjiGH0NItIpkpFhFFtqV7wTpC3wFQw/t7wgg61P0Dckiy64N9jjqSazzLKvIQqpVwL/BG3Mo88vYi6YFAAAAAElFTkSuQmCC)
 */
export const WidgetsMinusIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M18.45 1.85a3 3 0 0 0-4.1 1.1l-1.5 2.6a3 3 0 0 0 1.1 4.1l2.6 1.5a3 3 0 0 0 4.1-1.1l1.5-2.6a3 3 0 0 0-1.1-4.1l-2.6-1.5ZM2 5a3 3 0 0 1 3-3h3a3 3 0 0 1 3 3v3a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5ZM2 16a3 3 0 0 1 3-3h3a3 3 0 0 1 3 3v3a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-3ZM15 18a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-8Z"
        className={colorClass}
      />
    </svg>
  );
};
